import React, {useState} from 'react';
import {SubmitHandler, useForm} from "react-hook-form";
import {baseUrl} from "../../../../../constants/constants";
import {Props} from "../../obzor";
import {useAuth} from "../../../../../components/authProvider/authProvider";
import {errorToast, successToast} from "../../../../../shared/toastify";


interface ObzorForm{
    email: string,
    full_name: string,
    number_phone: string,
    busyness: string,
    title_article: string,
    theme_article_id: number,
    file_article: string,
    file_data_user: string,
    file_consent_data_processing: string,
    file_anti_plagiarism: string
}
const ObzorRegForm = ({close}:Props) => {
    const [metrikaCounted, setMetrikaCounted] = useState(false)
    const{register,
        handleSubmit,
        formState:{errors},
        setError} = useForm<ObzorForm>();
    const isAuth = useAuth()

    const sendMetrika = () => {
        if (!metrikaCounted) {
            setMetrikaCounted(true)
            // @ts-ignore
            ym(100105951,'reachGoal','obzor-request')
        }
    }
    
    const handleChange = (event: { target: { files: any; }; }) => {
        console.log(event.target.files);
    }

        const submit: SubmitHandler<ObzorForm> = async (data: any) => {
        try{
            const formData = new FormData()
            for(let key  in data){
                if(key == 'file_article' || key == 'file_data_user' || key == 'file_consent_data_processing' || key == 'file_anti_plagiarism'){
                    formData.append(key, data[key][0])
                } else { formData.append(key, data[key])}
            }
            const res = await fetch(`${baseUrl}blank_writer`, {
                method: 'POST',
                body: formData
            });
            if(res.status === 200){
                sendMetrika()
                localStorage.setItem('form', 'accepted');
                successToast('Заявка на публикацию отправлена!');
                close()
            } else if (res.status === 401){
                setError('root', {type: 'custom', message: ''})
            }
        } catch (err){
            console.error(err)
        }
    }

    return (
        <div>
            <form
                className='regForm'
                onSubmit={handleSubmit(submit)}
            >
                <input
                    type="text"
                    className='regInput'
                    placeholder='ФИО'
                    {...register('full_name',
                        {required: true,
                                value: isAuth?.authState.user?.full_name
                        })}/>
                {errors.full_name && <p className='wrong-message'>Это поле обязательно</p>}

                <input
                    type="text"
                    className='regInput'
                    placeholder='Место работы, должность(место учёбы, курс)'
                    {...register('busyness',
                        {required: true,
                        value: isAuth?.authState.user?.place_of_work}
                    )}/>
                {errors.busyness && <p className='wrong-message'>Это поле обязательно</p>}

                <input
                    type="text"
                    className='regInput'
                    placeholder='Название статьи'
                    {...register('title_article',
                        {required: true})}
                />
                {errors.title_article && <p className='wrong-message'>Это поле обязательно</p>}

                <label className='regLabel'>
                    Выпуск, в который направлена статья:
                    <select
                        id="name-of-journal"
                        {...register('theme_article_id', {required: true})}
                    >
                        <option value="1">«Фальсификация истории»</option>
                        <option value="2">«Исламизм»</option>
                        <option value="3">«Искусственный интеллект и безопасность»</option>
                        <option value="4">«Профилактика как часть воспитания в вузе»</option>
                    </select>
                </label>

                <span className="regInput__file">
                    <p>Файл статьи в .doc/.docx</p>
                    <input
                        type="file"
                        {...register('file_article', {required: true})}
                        accept='application/msword'
                    />
                    {errors.file_article && errorToast('Загрузите файл статьи')}
                </span>
                {errors.file_article && <p className='wrong-message'>Загрузите файл статьи</p>}

                <span className="regInput__file">
                    <p>Файл с данными об авторе (в любом формате)</p>
                    <input
                        type="file"
                        {...register('file_data_user', {required: true})}
                    />
                </span>
                {errors.file_data_user && <p className='wrong-message'>Загрузите файл с данными об авторе</p>}

                <span className="regInput__file">
                    <p>Файл с согласием на обработку ПДН в .pdf/.jpg/.jpeg</p>
                    <input
                        type="file"
                        {...register('file_consent_data_processing', {required: true})}
                        accept='application/pdf, image/jpg, image/jpeg'
                    />
                </span>
                {errors.file_consent_data_processing && <p className='wrong-message'>Загрузите файл с согласием на обработку ПДН</p>}
                {/*{errors.file_consent_data_processing && errorToast('Загрузите файл с согласием на обработку ПДН')}*/}

                <span className="regInput__file">
                    <p>Файл справки о проверке на антиплагиат (любой формат)</p>
                    <input
                        type="file"
                        {...register('file_anti_plagiarism', {required: true})}
                        accept='application/msword'
                    />
                </span>
                {errors.file_anti_plagiarism && <p className='wrong-message'>Загрузите файл справки о проверке на антиплагиат</p>}
                {/*{errors.file_anti_plagiarism && errorToast('Загрузите файл справки о проверке на антиплагиат')}*/}

                <input
                    type="email"
                    className='regInput'
                    placeholder='Контактные данные (Email)'
                    defaultValue={isAuth?.authState.user?.email}
                    {...register('email', {required: true})}
                />
                {errors.email && <p className='wrong-message'>Это поле обязательно</p>}

                <input
                    type="text"
                    className='regInput'
                    placeholder='Контактные данные (Телефон)'
                    defaultValue={isAuth?.authState.user?.number_phone == null ? '+7' : `+${isAuth?.authState.user?.number_phone}`}
                    {...register('number_phone',
                        {required: true})}
                />
                {errors.number_phone && <p className='wrong-message'>Это поле обязательно</p>}

                <button className="button form-btn">Отправить</button>
            </form>
        </div>
    );
};

export default ObzorRegForm;